import React, { Component } from 'react';
import Navigation from './Navigation';
import 'materialize-css/dist/css/materialize.min.css';
import jwt from 'jsonwebtoken';
import Moment from 'moment';
import * as CONS from '../CONS'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../style/RequestGift.css'
import title_solicitud from '../img/1x/title_solicitud.png'

class RequestGift extends Component {

    constructor(props) {
        super(props);
        if (!localStorage.getItem('jwtToken')) {
            this.props.history.push("/login");
        } else {
            var token = localStorage.getItem("jwtToken");
            const tokenDec = jwt.decode(token);
            if (tokenDec.level < 10)
                this.props.history.push("/login");
        }
    }

    state = {
        id_user: 0,
        id_rol: 0,
        level: 0,
        listMyRequest: [],
        listCurRequest: [],
        listPastRequest: [],
        listAllRequest: [],
        id_btn: 1,
        request_user: 0,
        request_user_point: 0,
        request_gift_point: 0,
        searchRequest: ''
    };


    async initFetch() {
        this.fetchUserAndRol();

    }

    async fetchUser(id_user) {

    }

    async fetchGift(id_gift) {

    }

    async fetchUserAndRol() {
        // User
        try {
            const token = localStorage.getItem("jwtToken");
            if (!token) { return; }
            const id_user = jwt.decode(token).id_user;

            const response = await fetch(localStorage.getItem("api") + '/user/' + id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({
                id_user: id_user,
                id_rol: data.rol
            });
        } catch (err) {
            console.log(err.toString())
            return;
        }

        // Rol
        try {
            const response = await fetch(localStorage.getItem("api") + '/rol/' + this.state.id_rol, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({ level: data.level });
        } catch (err) {
            console.log(err.toString())
            return;
        }

        this.fetchMyRequest();
        this.fetchCurRequest();
        this.fetchPastRequest();
        this.fetchAllRequest();
    }

    // Obtiene las solicitudes hechas por el usuario actual
    async fetchMyRequest() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/user/' + this.state.id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({ listMyRequest: data });
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    // Obtiene las solicitudes pendientes por aprobar o rechazar(jefe)
    async fetchCurRequest() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/current/' + this.state.id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({ listCurRequest: data });
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    // Obtiene las solicitudes ya aprobadas o rechazadas(jefe)
    async fetchPastRequest() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/past/' + this.state.id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({ listPastRequest: data });
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    // Obtiene todas solicitudes (Gestor)
    async fetchAllRequest() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({ listAllRequest: data });
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    getTableRequest() {
        switch (this.state.id_btn) {
            case 1:
                return this.listMyRequest();
            case 2:
                return this.listCurRequest();
            case 3:
                return this.listPastRequest();
            case 4:
                return this.listAllRequest();
            default:
                break;
        }
    }

    // Aprueba la solicitud
    async setApproved(id_request_gift) {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/' + id_request_gift, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(
                    { request_state: 2 }
                )
            })
            const data = await response.json();
            this.setState({ status: data.status });

            this.fetchMyRequest();
            this.fetchCurRequest();
            this.fetchPastRequest();
            this.fetchAllRequest();
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    };

    // Mensaje para confirmar la aceptación de la solicitud
    showMsjApproved(id_request_gift) {

        const MySwal = withReactContent(Swal);

        MySwal.fire({
            text: "¿Desea aprobar esta solicitud?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No, cancelar'
        }).then((result) => {
            if (result.value) {
                this.setApproved(id_request_gift);
            }
        });
    }

    // Mensaje donde se muestra el comentario del empleado a la solicitud
    showMsjComment(comment, request_date) {
        const MySwal = withReactContent(Swal);
        if (request_date) {
            MySwal.fire({
                html: "<p>Fecha solicitada: <b>" + Moment.utc(request_date).format('YYYY-MM-DD') + "</b></p>" +
                    "<p>" + comment + "</p>",
                customClass: {
                    content: 'custom-swal-content',
                }
            })
        } else {
            MySwal.fire({
                text: comment,
                customClass: {
                    content: 'custom-swal-content',
                }
            })
        }
    }

    showMsjCommentReject(comment_reject) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: "Solicitud rechazada",
            text: comment_reject,
            customClass: {
                content: 'custom-swal-content',
            }
        })
    }
    // Agregar puntos
    // Se devuelvon los puntos al empleado cuando la solicitud se rechaza
    // Se obtienen los puntos actuales del usuario que hizo la solicitud
    // Se obtienen los puntos que cuesta el regalo
    async addPoint(id_user, id_gift) {

        try {
            const response = await fetch(localStorage.getItem("api") + '/user/' + id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({
                request_user: id_user,
                request_user_point: data.point
            });
        } catch (err) {
            console.log(err.toString())
            return;
        }

        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/' + id_gift, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });

            const data = await response.json();
            this.setState({
                request_gift_point: data.point
            });
        } catch (err) {
            console.log(err.toString())
            return;
        }

        var newPoint = this.state.request_user_point + this.state.request_gift_point;

        try {
            const response = await fetch(localStorage.getItem("api") + '/user/point/' + this.state.request_user, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),

                body: JSON.stringify(
                    { point: newPoint }
                )
            });
            const data = await response.json();
            this.setState({ status: data.status });

        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
        }
    }


    // Rechaza la solicitud
    async setRefuse(id_request_gift, comment_reject) {
        try {
            const response = await fetch(localStorage.getItem("api") + '/request_gift/' + id_request_gift, {
                method: 'PUT',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(
                    { request_state: 3, comment_reject: comment_reject }
                )
            })
            const data = await response.json();
            this.setState({ status: data.status });

            this.fetchMyRequest();
            this.fetchCurRequest();
            this.fetchPastRequest();
            this.fetchAllRequest();

            return true;
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });

            return false;
        }
    }

    // Mensaje para confirmar el rechazo de la solicitud
    showMsjRefuse(id_request_gift, id_user, id_gift) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: "Rechazo de solicitud",
            text: "Escriba el detalle sobre el rechazo de la solicitud.",
            input: 'textarea',
            inputAttributes: {
                autocapitalize: 'off'
            },
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, rechazar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Recuerda detallar porque rechazas esta solicitud'
                } else if (value.length > 300) {
                    return 'El comentario supera los 300 carácteres'
                }
            },
        }).then((result) => {
            if (result.value) {
                if (this.setRefuse(id_request_gift, result.value)) {
                    // this.fetchGift(id_gift);
                    // this.fetchUser(id_user);

                    this.addPoint(id_user, id_gift);
                } else {
                    console.log("Error al rechazar la solicitud");
                }
            }
        });
    }

    // Muestra todas las solicitudes enviadas por el usuario actual
    listMyRequest() {
        var { listMyRequest, searchRequest } = this.state;

        listMyRequest = listMyRequest.filter(f =>
            f.document_num.toString().toLowerCase().includes(searchRequest) ||
            f.gift_name.toString().toLowerCase().includes(searchRequest) ||
            f.boss_name.toString().toLowerCase().includes(searchRequest.toString().toLowerCase()) ||
            f.request_state_name.toString().toLowerCase().includes(searchRequest)
        );

        return <table>
            <thead>
                <tr>
                    <th>Regalo</th>
                    <th>Jefe</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                {listMyRequest.map((request, key) => {
                    const { id_request_gift, gift_name, boss_name,
                        request_state_name, updated_at, request_state, comment_reject } = request;
                    return <tr key={id_request_gift}>
                        <td>{gift_name}</td>
                        <td>{boss_name}</td>
                        <td className={`request_state_${request_state}`}>{request_state_name}
                            {request_state === 3 ?
                                <a href="#!" className="icon_comment_reject" onClick={() => this.showMsjCommentReject(comment_reject)}>
                                    <i className="material-icons">comment</i>
                                </a> : null}
                        </td>
                        <td>{Moment(updated_at).format('YYYY-MM-DD hh:mm a')}</td>
                    </tr>;

                })}
            </tbody>
        </table>;
    }

    // Muestra las solicitudes del jefe que no han sido aprobadas/rechazadas
    listCurRequest() {
        var { listCurRequest, searchRequest } = this.state;

        listCurRequest = listCurRequest.filter(f =>
            f.user_name.toString().toLowerCase().includes(searchRequest) ||
            f.document_num.toString().toLowerCase().includes(searchRequest) ||
            f.gift_name.toString().toLowerCase().includes(searchRequest)
        );

        return <table>
            <thead>
                <tr>
                    <th>Usuario</th>
                    <th>Regalo</th>
                    <th>Fecha</th>
                    <th>Acción</th>
                </tr>
            </thead>
            <tbody>
                {listCurRequest.map((request, key) => {
                    const { id_request_gift, user, gift, user_name, gift_name, updated_at, document_num, comment, request_date } = request;
                    return <tr key={id_request_gift}>
                        <td><b>{user_name}</b><br></br><span>{document_num}</span></td>
                        <td>{gift_name}</td>
                        <td>{Moment(updated_at).format('YYYY-MM-DD hh:mm a')}</td>
                        <td>
                            <a href="#!" className="waves-effect waves-light btn" onClick={() => this.showMsjApproved(id_request_gift)}><i className="material-icons">check</i></a>
                            <a href="#!" className="waves-effect waves-light btn" onClick={() => this.showMsjComment(comment, request_date)}><i className="material-icons">comment</i></a>
                            <a href="#!" className="waves-effect waves-light btn red" onClick={() => this.showMsjRefuse(id_request_gift, user, gift)}><i className="material-icons">close</i></a>
                        </td>
                    </tr>;

                })}
            </tbody>
        </table>;
    }

    // Muestra las solicitudes que el jefe ha aprobado/rechazado
    listPastRequest() {
        var { listPastRequest, searchRequest } = this.state;

        listPastRequest = listPastRequest.filter(f =>
            f.document_num.toString().toLowerCase().includes(searchRequest) ||
            f.document_num2.toString().toLowerCase().includes(searchRequest) ||
            f.user_name.toString().toLowerCase().includes(searchRequest) ||
            f.gift_name.toString().toLowerCase().includes(searchRequest) ||
            f.boss_name.toString().toLowerCase().includes(searchRequest.toString().toLowerCase()) ||
            f.request_state_name.toString().toLowerCase().includes(searchRequest)
        );
        return <table>
            <thead>
                <tr>
                    <th>Usuario</th>
                    <th>Regalo</th>
                    <th>Jefe</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                {listPastRequest.map((request, i) => {
                    const { user_name, gift_name, boss_name, request_state_name, updated_at, request_state } = request;
                    return <tr key={i}>
                        <td>{user_name}</td>
                        <td>{gift_name}</td>
                        <td>{boss_name}</td>
                        <td className={`request_state_${request_state}`}>{request_state_name}</td>
                        <td>{Moment(updated_at).format('YYYY-MM-DD hh:mm a')}</td>
                    </tr>;

                })}
            </tbody>
        </table>;
    }

    // Muestra todas las solicitudes
    listAllRequest() {
        var { listAllRequest, searchRequest } = this.state;

        listAllRequest = listAllRequest.filter(f =>
            f.document_num.toString().toLowerCase().includes(searchRequest) ||
            f.document_num2.toString().toLowerCase().includes(searchRequest) ||
            f.user_name.toString().toLowerCase().includes(searchRequest) ||
            f.gift_name.toString().toLowerCase().includes(searchRequest) ||
            f.boss_name.toString().toLowerCase().includes(searchRequest.toString().toLowerCase()) ||
            f.request_state_name.toString().toLowerCase().includes(searchRequest)
        );
        return <table>
            <thead>
                <tr>
                    <th>Usuario</th>
                    <th>Regalo</th>
                    <th>Jefe</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                </tr>
            </thead>
            <tbody>
                {listAllRequest.map((request, key) => {
                    const { user_name, gift_name, boss_name,
                        request_state_name, updated_at, request_state } = request;
                    return <tr key={key}>
                        <td>{user_name}</td>
                        <td>{gift_name}</td>
                        <td>{boss_name}</td>
                        <td className={`request_state_${request_state}`}>{request_state_name}</td>
                        <td>{Moment(updated_at).format('YYYY-MM-DD hh:mm a')}</td>
                    </tr>;

                })}
            </tbody>
        </table>;
    }

    setIdBtnState(e) {
        this.setState({ id_btn: parseInt(e.target.value) });
    }

    /*
        Actualiza el estado según un cambio en el Input correspondiente
    */
    handleInputSearch = (e) => {
        this.setState({
            searchRequest: e.target.value.toString().toLowerCase()
        });
    }

    componentDidMount() {
        this.initFetch();
    }

    render() {
        var btnRol = <img src={title_solicitud} alt="title_solicitud" className="responsive-img" />;
        if (this.state.level >= 15) {
            btnRol =
                <div className="row ">
                    <button className="btn " onClick={(e) => this.setIdBtnState(e)} value="1">Mis solicitudes</button>
                    <button className="btn" onClick={(e) => this.setIdBtnState(e)} value="2">Pendientes</button>
                    <button className="btn " onClick={(e) => this.setIdBtnState(e)} value="3">Histórico</button>
                    <button className="btn " onClick={(e) => this.setIdBtnState(e)} value="4">Todas las solicitudes</button>
                </div>;
        } else if (this.state.level >= 12) {
            btnRol = <div className="row">
                <button className="btn" onClick={(e) => this.setIdBtnState(e)} value="1">Mis solicitudes</button>
                <button className="btn " onClick={(e) => this.setIdBtnState(e)} value="2">Pendientes</button>
                <button className="btn " onClick={(e) => this.setIdBtnState(e)} value="3">Histórico</button>
            </div>;
        }

        return (
            <React.Fragment>
                <div className="shape-border-left hide-on-med-and-down"></div>
                <Navigation></Navigation>
                <div id="RequestGift">
                    <div className="container">
                        <div className="btn-options">
                            {btnRol}
                        </div>
                        <div className="row">
                            <div className="input-field col s12 m6 offset-m6">
                                <i className="material-icons prefix">search</i>
                                <input id="icon_prefix" type="text" className="validate" name="searchRequest" onChange={(e) => this.handleInputSearch(e)} value={this.state.searchRequest}></input>
                                <label htmlFor="icon_prefix">Búsqueda</label>
                            </div>
                        </div>
                        <div className="">
                            {this.getTableRequest()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };

}

export default RequestGift;